<template>
  <v-app>
    <v-container fluid>
     
      <v-card>
        <div class="row ml-5 mt-5">
        <BackBtn />
      </div>
        <v-layout row wrap>
          <v-flex xs12 sm6 md3 lg3>
            <v-hover v-slot="{ hover }" open-delay="200">
              <v-card class="text-xs-center ma-3" max-width="344" :elevation="hover ? 16 : 2"
                :class="{ 'on-hover': hover }" link to="/more_about_status">
                <v-card-title>Total Documents</v-card-title>
                <v-card-text><span>
                    <center>
                      <v-chip color="#3cd1c2">{{
                        15
                      }}</v-chip>
                    </center>
                  </span></v-card-text>
                <v-icon small color="#3cd1c2">mdi-comment-check</v-icon>
              </v-card>
            </v-hover>
          </v-flex>
          <v-flex xs12 sm6 md3 lg3>
            <v-hover v-slot="{ hover }" open-delay="200">
              <v-card raised class="text-xs-center ma-3" max-width="344" :elevation="hover ? 16 : 2"
                :class="{ 'on-hover': hover }" link to="/more_about_status">
                <v-card-title>Shared Documents</v-card-title>
                <v-card-text><span>
                    <center>
                      <v-chip color="#f83e70">{{
                        10
                      }}</v-chip>
                    </center>
                  </span></v-card-text>
                <v-icon small color="#f83e70">mdi-cached</v-icon>
              </v-card>
            </v-hover>
          </v-flex>
          <v-flex xs12 sm6 md3 lg3>
            <v-hover v-slot="{ hover }" open-delay="200">
              <v-card class="text-xs-center ma-3" max-width="344" :elevation="hover ? 16 : 2"
                :class="{ 'on-hover': hover }" link to="/more_about_status">
                <v-card-title>Pending Documents</v-card-title>
                <v-card-text><span>
                    <center><v-chip color="#ffaa2c">5</v-chip></center>
                  </span></v-card-text>
                <v-icon small color="#ffaa2c">mdi-comment-processing</v-icon>
              </v-card>
            </v-hover>
          </v-flex>
          <v-flex xs12 sm6 md3 lg3>
            <v-hover v-slot="{ hover }" open-delay="200">
              <v-card class="text-xs-center ma-3" max-width="344" :elevation="hover ? 16 : 2"
                :class="{ 'on-hover': hover }" link to="/more_about_status">
                <v-card-title>Received Documents</v-card-title>
                <v-card-text><span>
                    <center>
                      <v-chip color="primary">{{
                        5
                      }}</v-chip>
                    </center>
                  </span></v-card-text>
                <v-icon small color="primary">mdi-comment-flash</v-icon>
              </v-card>
            </v-hover>
          </v-flex>
        </v-layout>
        <br /><br />
        <v-divider> </v-divider>
        <br />
        <v-layout row wrap>
          <v-flex xs12 md6>
            <div>
              <v-card class="text-xs-center ma-3" max-width="500">
                <apexcharts width="500" height="350" type="bar" :options="chartOptions" :series="series"></apexcharts>
              </v-card>
            </div>
          </v-flex>
          <v-flex xs12 md6>
            <div>
              <v-card class="text-xs-center ma-3" max-width="500">
                <apexcharts type="polarArea" :options="chartOptions1" :series="series1"></apexcharts>
              </v-card>
            </div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
  </v-app>
</template>
  
<script>
import VueApexCharts from "vue-apexcharts";
import BackBtn from "../SharedComponent/Button/BackBtn.vue"
export default {

  components: {
    apexcharts: VueApexCharts,
    BackBtn,
  },
  data: function () {
    return {
      countCompletedStaffAppointments: null,
      chartOptions: {
        chart: {
          id: "basic-bar",
        },
        xaxis: {
          categories: [
            "Completed",
            "Ongoing",
            "Delayed",
            "On Progress",
            "On Production",
          ],
        },
      },
      series: [
        {
          name: "Completed",
          data: [10, 50, 49, 60, 91],
        },
      ],
      series1: [21, 17, 15, 10, 30],
      chartOptions1: {
        chart: {
          type: "polarArea",
        },
        stroke: {
          colors: ["#fff"],
        },
        fill: {
          opacity: 0.8,
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
    };
  },


  
};
</script>
  
<style>
.small {
  max-width: 600px;
  margin: 150px auto;
}
</style>